/**
 * The media-cast signal kinds accepted over the transport.
 */
const MEDIA_CAST_SIGNAL_KINDS = new Set([
    'answer',
    'candidate',
    'mute',
    'offer',
    'restart',
    'stop'
]);
/**
 * Checks whether an unknown value is a well-formed media-cast signal, so malformed messages
 * received from the host are rejected before they reach the WebRTC layer.
 *
 * @param {unknown} value - Value received over the application transport.
 * @returns {boolean} Whether the value is a well-formed media-cast signal.
 */
export function isMediaCastSignal(value) {
    if (typeof value !== 'object' || value === null) {
        return false;
    }
    const signal = value;
    const { kind } = signal;
    if (typeof kind !== 'string' || !MEDIA_CAST_SIGNAL_KINDS.has(kind)) {
        return false;
    }
    if (typeof signal.generation !== 'number') {
        return false;
    }
    switch (kind) {
        case 'answer':
        case 'offer': {
            const sdp = signal.sdp;
            return typeof sdp === 'object' && sdp !== null
                && typeof sdp.type === 'string'
                && typeof sdp.sdp === 'string';
        }
        case 'candidate':
            return typeof signal.candidate === 'object' && signal.candidate !== null;
        case 'mute':
            return typeof signal.muted === 'boolean';
        case 'restart':
        case 'stop':
            return true;
        default:
            return false;
    }
}
